<template>
  <eco-labeled-control
    :context="context"
    :attributes="attributes"
  >
    <div class="value">
      <span>{{ currentValue }}</span>
    </div>
  </eco-labeled-control>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ControlContextV2, TimeDisplayControlAppearance, TimeDisplayControlAttributes, TimeDisplayControlTimeType } from './models'

import EcoLabeledControl from './shared/EcoLabeledControl.vue'

import moment from 'moment'
  
@Component({
  components: {
    EcoLabeledControl,
  },
})
export default class EcoTimeDisplayControl extends Vue {
  @Prop() public id: string
  @Prop() public context: ControlContextV2
  @Prop() public attributes: TimeDisplayControlAttributes
  @Prop() public state: object

  public invalidTime = 'n/a'

  public get currentValue() {
    const value = this.state[this.attributes.state]
    if (!value) {
      return this.invalidTime
    }
    return this.format(this.parse(value))
  }

  public parse(value) {
    switch (this.attributes.timeType) {
      case TimeDisplayControlTimeType.UnixSeconds: 
        return moment.unix(value)
      case TimeDisplayControlTimeType.UnixMilliseconds: 
        return moment.utc(value)
      default: 
        return undefined
    }
  }

  public format(time: moment.Moment | undefined) {
    if (!time) {
      return this.invalidTime
    }
    switch (this.attributes.appearance) {
      case TimeDisplayControlAppearance.DDMMYYYYHHmmss: 
        return time.local().format('DD.MM.YYYY HH:mm:ss')
      default: 
        return this.invalidTime
    }
  }
}
</script>

<style lang="scss" scoped>
  .value {
    display: flex;
    flex-direction: row;
    padding: 5px 5px;
    line-height: 1.2;
    border-radius: 5px;
    background: rgba(123, 139, 154, 0.1);
    align-self: center;
}
</style>

<style lang="css">
</style>
